exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FilterMenu-module__heading___KbYv8{display:grid;gap:12px;color:#707070;grid-template-columns:auto 1fr;align-items:center;font-weight:600;margin-bottom:4px}.FilterMenu-module__wrapper___33OVx{background-color:#e8f7fc;padding:24px;border-radius:35px;display:grid;gap:24px;align-content:start;align-self:start}.FilterMenu-module__checkboxes___iRFdE{display:grid;gap:6px}.FilterMenu-module__checkboxes___iRFdE .FilterMenu-module__checkbox___2nt3L{cursor:pointer;display:grid;grid-template-columns:auto 1fr;gap:12px;color:#707070}.FilterMenu-module__checkboxes___iRFdE .FilterMenu-module__checkbox___2nt3L.FilterMenu-module__selected___2TRS6{color:#9e7fc9}", ""]);

// exports
exports.locals = {
	"heading": "FilterMenu-module__heading___KbYv8",
	"wrapper": "FilterMenu-module__wrapper___33OVx",
	"checkboxes": "FilterMenu-module__checkboxes___iRFdE",
	"checkbox": "FilterMenu-module__checkbox___2nt3L",
	"selected": "FilterMenu-module__selected___2TRS6"
};